import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"error\"><g clip-path=\"url(#error_a)\"><circle cx=\"12\" cy=\"12\" r=\"10\" stroke=\"#DB3259\" stroke-width=\"2\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 6.5a1 1 0 0 1 1 1V13a1 1 0 1 1-2 0V7.5a1 1 0 0 1 1-1zM11 17c0-.552.445-1 .995-1h.01c.55 0 .995.448.995 1s-.445 1-.995 1h-.01A.998.998 0 0 1 11 17z\" fill=\"#DB3259\" /></g><defs><clipPath id=\"error_a\"><path fill=\"#fff\" transform=\"translate(1 1)\" d=\"M0 0h22v22H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/error.svg
// module id = 160
// module chunks = 0